import { Service } from '@angular/core';

import { type ContentType } from '../../enums/content-type';

import { type S3PresignedUrlRequestDto } from './dto/s3-presigned-url.dto';
import { type IMapperToDto } from './mappers';

/** Data required to obtain a presigned URL for uploading a file to a bucket. */
export type S3PresignedUrlRequest = Readonly<{

	/** Destination of the media file. */
	destination: string;

	/** Content type of the uploaded file. */
	contentType: ContentType;

	/** Media extension. */
	extension: string;
}>;

/** S3 presigned URL request mapper. */
@Service()
export class S3PresignedUrlRequestMapper implements IMapperToDto<S3PresignedUrlRequestDto, S3PresignedUrlRequest> {
	/** @inheritdoc */
	public toDto(data: S3PresignedUrlRequest): S3PresignedUrlRequestDto {
		return {
			destination: data.destination,
			content_type: data.contentType,
			extension: data.extension,
		};
	}
}
